/**
 * GSAP scroll interactions module.
 *
 * Initialize and register GSAP plugins for custom scroll-based animations.
 * Add interaction functions as needed.
 *
 * @since 1.0.0
 */

import gsap, { ScrollTrigger } from '../../vendor/gsap/esm/all.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Parallax effect for staggered split-image columns.
 *
 * Expects a section with `overflow: hidden` and a max-height that crops the
 * images. Each image should be taller than its container (e.g. `height: 120%`
 * with `object-fit: cover`) so the translation has room to move.
 *
 * Creates a dramatic staggered parallax with rotation and scale for visual depth.
 *
 * @since 1.0.0
 */
export function initParallaxSplitImages() {
    const section = document.querySelector('.parallax-split');

    if (!section) {
        return;
    }

    const columns = section.querySelectorAll('.col-img');

    if (!columns.length) {
        return;
    }

    const scrollTriggerBase = {
        trigger: section,
        start: '-50% top',
        end: 'bottom top',
        scrub: 3
    };

    // Left column: fast parallax.
    gsap.fromTo(
        columns[0],
        { y: 60 },
        {
            y: -250,
            ease: 'none',
            scrollTrigger: scrollTriggerBase,
        }
    );

    // Right column: slower parallax for stagger.
    gsap.fromTo(
        columns[1],
        { y: 120 },
        {
            y: -350,
            ease: 'none',
            scrollTrigger: scrollTriggerBase,
        }
    );
}
